import React from "react";
import "../../styles/pagination.css";

/**
 * Reusable pagination component
 * @param {Object} props - Component props
 * @param {number} props.currentPage - Current page number
 * @param {number} props.totalPages - Total number of pages
 * @param {boolean} props.hasPrevPage - Whether there is a previous page
 * @param {boolean} props.hasNextPage - Whether there is a next page
 * @param {Function} props.onPageChange - Callback for page change
 * @returns {JSX.Element} - Pagination component
 */
export const Pagination = ({ 
  currentPage, 
  totalPages, 
  hasPrevPage = currentPage > 1,
  hasNextPage = currentPage < totalPages, 
  onPageChange 
}) => {
  return (
    <div className="pagination-controls">
      <button
        className="submit-btn"
        onClick={() => onPageChange(Math.max(1, currentPage - 1))}
        disabled={!hasPrevPage}
      >
        Previous
      </button>
      <span className="page-info">
        Page {currentPage} of {totalPages}
      </span>
      <button
        className="submit-btn"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={!hasNextPage}
      >
        Next
      </button>
    </div>
  );
};
